import Vue from 'vue'

Vue.prototype.$DAformattedDate = value => {
  const parts = value.split('-')
  const year = Number(parts[0])
  const month = Number(parts[1])
  const day = Number(parts[2])
  const formattedDate = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''}${month}-${year}`
  return formattedDate
}

Vue.prototype.$FormformattedDate = value => {
  const parts = value.split('-')
  const day = Number(parts[0])
  const month = Number(parts[1])
  const year = Number(parts[2])
  const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`
  return formattedDate
}
